import { render, staticRenderFns } from "./app-wrapper-container.vue?vue&type=template&id=3471d9cf&scoped=true&"
import script from "./app-wrapper-container.vue?vue&type=script&lang=js&"
export * from "./app-wrapper-container.vue?vue&type=script&lang=js&"
import style0 from "./app-wrapper-container.vue?vue&type=style&index=0&id=3471d9cf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3471d9cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
